//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import { CircularProgress } from '@mui/material';
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
import { Tooltip } from 'antd';
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleListGame } from 'store/one_game/thunks';
import styled from "styled-components";
import { IGameHome8 } from "utils/assets/images";
import GameLoader from "./GameLoaader";
import { useCurrentUser } from 'store/users/selectors';
import { get } from 'lodash'

const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? `'${p.src}'`: IGameHome8});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;

const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 414,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};
export default function AllTeachersGame({ showDrawer, setCurrentSection, bookId, pageId, userId, gameDuplicateLoader, startGame, gameInitLoader, onDuplicateGame = () => { }, previewGame, gameType, newMaskId }) {
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const isAdmin = get(currentUser, "role") === "owe_admin";

    const loadData = async () => {
        setLoading(true)
        const {data} = await dispatch(handleListGame(userId, bookId, pageId, 'other_game', '1game'))
        if (data && Array.isArray(data)) {
            // setGames(data)
         
            if (gameType === 'modern') {
                const moderGame = data.filter(item => item?.game_mode === 'modern');
                setGames(moderGame);
            }
            else if (gameType === 'classic') {
                const moderGame = data.filter(item => item?.game_mode === 'classic');
                setGames(moderGame);
            }
            else {
                setGames(data);
            }
        }
        setLoading(false);
    }
    useEffect(() => {
        loadData();
    }, [pageId, gameType])
    if (isLoading) {
        return (<GameLoader />);
    }
    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No games available!</div>
        </div>
        )
    }

    return (
        <Slider {...settings}>
            {games.map((item, index) => {
                const image_url = item.media_urls ? item.media_urls.image : IGameHome8
                const isGameLoading = gameInitLoader && selectedGame.game_id === item.game_id
                return (
                    <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                        <div className='myUnitsBnr draftImage-game frameStyle'>
                            {/* <Cover src={image_url} /> */}
                            <img
                                src={image_url}
                                alt=""
                                className='imageStyle'
                            />
                            {item?.status === 'false' && (
                                <div className='draftText-game'>Draft</div>
                            )}
                            {item?.modern_type === "magic_goal" && (
                                <div className='draftText SoccerTag'>Goal</div>
                            )}
                            {item?.modern_type === "run" && (
                                <div className='draftText SoccerTag'>Run</div>
                            )}
                            {item?.modern_type === "king_jump" && (
                                <div className='draftText SoccerTag'>Jump</div>
                            )}
                            {item?.modern_type === "park" && (
                                <div className='draftText SoccerTag'>Park</div>
                            )}
                            {item?.game_mode === "classic" && (
                                <div className='draftText classiscTag'>Classic</div>
                            )}
                        </div>
                        <div className='myUnitsTxt'>
                            <div className='myUnitsInfo'>
                                {item?.display_name && item.display_name.length > 20 ? (
                                    <Tooltip title={item.display_name}>
                                        <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label>
                                    </Tooltip>
                                ) : (
                                    <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                )}
                                <p>{item?.category?.category_name || "--"}</p>
                                {newMaskId ? (
                                    <span>Pg. {newMaskId || '--'}</span>
                                ) : (
                                    <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                                )}
                                <span>{`No. of Questions: ${item?.question_length}`}</span>
                            </div>
                            <div className='myUnitsBtns'>
                                <a onClick={() => {
                                    if (item?.status === 'true' && item?.question_length > 0) {
                                        previewGame(item)
                                   }
                                }
                                    // previewGame(item?.game_id)
                                
                                } className={`BtnsPrev ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`}>Preview</a>
                                {!isAdmin && (
                                <a onClick={() => {
                                    if (isGameLoading || gameInitLoader) {
                                        return false;
                                    }
                                    if (item?.status === 'true'&&item?.question_length>0) {
                                        setSelectedGame(item);
                                        startGame(item);
                                    }
                                }}
                                    className={`BtnsStart ${item?.status !== 'true'||item?.question_length==0 ? "btn-disabled-game" : ''}`}>
                                    <ArrowRightRounded />{gameInitLoader && selectedGame.game_id === item.game_id ? <Loading size={12} white /> : null} start
                                </a>
                                )}
                            </div>
                            <div className='myUnitsBtm'><p><CheckCircleRounded /> Teacher Created</p></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="px-4">
                                <div onClick={() => {
                                    onDuplicateGame(item)
                                }}>
                                    {/* <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>{gameDuplicateLoader === item.game_id  ? <Loading size={12} /> : null} Duplicate</p> */}
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>{gameDuplicateLoader === item.game_id  ? <CircularProgress size={15} style={{ color: 'teal' }} /> : null} Duplicate</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Slider>
    )
}